import { View } from 'react-native';
import Svg, { Path, Rect } from 'react-native-svg';

const IdeaLamp = ({ height, width, color }) => {
    return (
        <View>
            <Svg
                width={width}
                height={height}
                viewBox="0 0 64 64"
                fill="none"
            >
                <Path
                    d="M32,16.1c-7.9,0-14.2,6.4-14.3,14.3c0,5.6,3.2,10.4,8,12.8v4.8v2v5.3h1.6l1.8,5.3h5.9l0.2-0.7l1.5-4.6h1.6v-1v-4.3v-2v-4.8
          c4.7-2.3,7.9-7.2,8-12.8C46.2,22.5,39.9,16.1,32,16.1z M27.7,53.2v-3.3h8.6v3.3H27.7z M33.5,58.5h-3l-1.1-3.3h5.2L33.5,58.5z
          M36.9,41.6l-0.6,0.3v6.1H33v-9.7c1-0.4,1.8-1.4,1.8-2.6c0-1.5-1.2-2.8-2.8-2.8c-1.5,0-2.8,1.2-2.8,2.8c0,1.2,0.7,2.2,1.8,2.6v9.7
          h-3.3v-6.1l-0.6-0.3c-4.3-1.9-7.4-6.2-7.3-11.2c0-3.4,1.4-6.4,3.6-8.7c2.2-2.2,5.3-3.6,8.7-3.6c3.4,0,6.4,1.4,8.7,3.6
          c2.2,2.2,3.6,5.3,3.6,8.7C44.3,35.4,41.2,39.7,36.9,41.6z M32,36.4c-0.4,0-0.8-0.3-0.8-0.8c0-0.4,0.3-0.8,0.8-0.8
          c0.4,0,0.8,0.3,0.8,0.8C32.8,36.1,32.4,36.4,32,36.4z"
                    fill={color}
                />
                <Rect x="31" y="3.5" width="2" height="7" fill={color} />
                <Rect x="53" y="30.5" width="7" height="2" fill={color} />
                <Rect x="4" y="30.5" width="7" height="2" fill={color} />
                <Rect
                    x="45.8"
                    y="13.2"
                    width="7"
                    height="2"
                    transform="rotate(-45 45.8 13.2)"
                    fill={color}
                />
                <Rect
                    x="13.7"
                    y="10.7"
                    width="2"
                    height="7"
                    transform="rotate(-45 13.7 10.7)"
                    fill={color}
                />
            </Svg>
        </View>
    );
};

export default IdeaLamp;
